import { useEffect, useRef } from "react";

export function useKeyboardBarcode(onScan: (code: string) => void) {
  const buffer = useRef("");
  const lastTime = useRef(0);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const now = Date.now();

      if (now - lastTime.current > 120) buffer.current = "";

      if (e.key === "Enter") {
        if (buffer.current.length >= 4) {
          onScan(buffer.current);
        }
        buffer.current = "";
      } else if (/^[a-zA-Z0-9]$/.test(e.key)) {
        buffer.current += e.key;
      }

      lastTime.current = now;
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onScan]);
}
